import storage from './storage'

import runtimeConfig from '@config/runtime'

export const userToken = storage.get('userToken') || storage.get('accessToken')
export const isNeedSilentLogin =
  storage.get('userToken') && storage.get('userToken').includes('Bearer')
export const isOldToken =
  !storage.get('accessToken') && storage.get('userToken')

export const buildAuthorizationHeader = () => {
  const userToken = storage.get('userToken')
  const accessToken = storage.get('accessToken')
  return {
    ...(userToken && { 'X-Spree-Token': userToken }),
    ...(accessToken && { authorization: `Bearer ${accessToken}` })
  }
}

export const buildLoginURL = ({ silent, next = '%2F' } = {}) => {
  const params = new URLSearchParams({
    client_id: runtimeConfig.identityClientId,
    redirect_uri: `${runtimeConfig.identityCallbackURL}/?next=${next}${
      silent ? '&silent=true' : ''
    }`,
    scope: 'openid',
    response_type: 'code'
  }).toString()

  return `${runtimeConfig.identityAuthorityURL}/auth?${params}`
}
